import React, {useEffect} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";
import $ from "jquery";

import {
  addToCart,
  changeCartFeature,
  toggleSelectionFeatureInfo
} from "../../../actions/actionFunctions";
import {getCurrentLayout} from "../../appLayout";
import {changeQTRoutePath} from "../../../misc/changeRoutePath";
import {subPartIsDone} from "../../selectionWindow/subPartDoneCheckMark";
import {changeSqftFeaturesPopup, setSqftFromFeature} from "../../../actions/sqftFunctions";
import WithCloseSQFtCalc from "../../sqft/hocs/withCloseSQFtCalc";
import WithAddToQuote from "../../sqft/hocs/withAddToQuote";
import {updateQuoteRoomsForCartItems, updateSQFTCreatedStatusForQuotes} from "../../../misc/categorySwitchingFunctions";
import {setQuotes} from "../../../actions/roomsFunctions";
import {MEASURE_UNITS, PARENT_KEYS_WITH_COMBINED_FEATURES_IN_CART, SQFT_FEATURES} from "../../sqft/constants";
import {setRelatedGroups} from "../../../actions/selectionFunctions";
import {
  setWizardValuesFromCartItems,
  switchToWizardItem
} from "../../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {showWizardInsteadOfQT} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {IS_PRODUCT_JOURNEY} from "../../../config";
import {setWizardSqftCartItems} from "../../../actions/wizardFunctions";
import {getWizardGroupsFromTheWizard} from "../../sqft/helpers/sqftHelperUi";
import {
  //deleteCartItemsThatAreMissingInSQFTCalcData,
  deleteSQFTCartItems,
  updateActiveQuoteWithSQFTData
} from "../../sqft/helpers/sqftQuotesHelper";
import {isSqftPassedDataEmpty} from "../../sqft/helpers/dataHelper";

const SqftFeaturesPopupApplyButton = (props) => {

  const {closePopup, parentsLists, addToCart, qtActiveCategory, activeQuoteIndex, sqftFeaturesPopup,
    changeSqftFeaturesPopup, toggleSelectionFeatureInfo, cartItems, relatedGroups, setRelatedGroups, wizardList,
    wizardIsActive, wizardActiveItem, quotes, setWizardSqftCartItems, fabricatorSettings} = props;

  const {visited, previouslyAddedSqftFeatures} = sqftFeaturesPopup;

  useEffect(() => {
    return () => {
      if (!visited) {
        changeSqftFeaturesPopup({
          visited: true
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // console.log("parentsList", parentsList);

  const skipAddedSteps = () => {
    const layout = getCurrentLayout();
    if (!window.location.href.includes('materials')) {
      return;
    }
    if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
      switchToWizardItem(wizardActiveItem);
    } else if (layout.qtCategories) {
      const qtCategory = layout.qtCategories.find(qtCategory => qtCategory.name === qtActiveCategory);
      if (!qtCategory) {
        return
      }
      const nextSubPartIndex = qtCategory.subParts.findIndex(subPartItem => {
        return !subPartIsDone(subPartItem.part, activeQuoteIndex, cartItems)
          && subPartItem.part.partId !== SQFT_FEATURES.slabs // skip slabs subpart
      });
      if (Number.isInteger(nextSubPartIndex)) {
        toggleSelectionFeatureInfo(null);
        changeQTRoutePath(qtActiveCategory, nextSubPartIndex);
      }
    }
  }

  const disabled = !parentsLists || parentsLists.some(parentsList => {
    return Object.keys(parentsList).some(parentKey => {
      if (!parentsList[parentKey] || !parentsList[parentKey].features) {
        return false
      }
      const sqftFeatures = parentsList[parentKey].features;
      if (sqftFeatures && sqftFeatures.length) {
        return sqftFeatures.some(sqftFeature => !sqftFeature || !sqftFeature.feature)
      }
      return false
    })
  })

  const applyButtonClick = async (closeSQFtCalc, prepareSQFTData) => {
    if (disabled) {
      const $scrollList = $(".ui-popup__body-content");
      const $scrollToFeature = $(".sqft-popup__feature[data-feature='false']");
      // console.log("$scrollToFeature", $scrollToFeature);
      if ($scrollList && $scrollToFeature && $scrollToFeature.offset()) {
        $scrollList.animate({scrollTop: $scrollToFeature.offset().top}, 800);
      }
      return false
    }
    let addedFeatures = [];
    let cabinetFeatures = [];
    let newPreviouslySelectedFeatures = [...previouslyAddedSqftFeatures];
    parentsLists.forEach(parentsList => {
      Object.keys(parentsList).forEach(parentKey => {
        if (!parentsList[parentKey]) {
          return;
        }

        if (parentsList[parentKey].features && parentsList[parentKey].features.length) {
          let sqftFeatures = prepareSqftFeaturesBeforeAddToCart(parentsList[parentKey].features, parentKey, parentsList.quoteIndex);
          processSqftFeatures(sqftFeatures, parentKey, parentsList);
        }

        if (parentsList[parentKey].featuresSubGroups) {
          for (const featureGroup of parentsList[parentKey].featuresSubGroups) {
            if (featureGroup && featureGroup.features && featureGroup.features.length) {
              let sqftFeatures = prepareSqftFeaturesBeforeAddToCart(featureGroup.features, parentKey, parentsList.quoteIndex);
              processSqftFeatures(sqftFeatures, parentKey, parentsList, featureGroup.subGroupTitle);
            }
          }
        }
      });
    });

    function processSqftFeatures(sqftFeatures, parentKey, parentsList, subGroupTitle = '') {
      for (const sqftFeature of sqftFeatures) {
        if (sqftFeature.isDisabledInPopup ) {
          continue;
        }
        if (sqftFeature.subPart) {
          sqftFeature.subPart.part.placeholderChanged = true;
          sqftFeature.subPart.part.firstClick[activeQuoteIndex] = true;
        }
        if (sqftFeature.feature && !sqftFeature.disabled) {
          const fromVisualizerType =
            quotes && quotes[parentsList.quoteIndex] && quotes[parentsList.quoteIndex].room
              ? quotes[parentsList.quoteIndex].room
              : document.kvConfig.visualizerType;
          const shouldSkipCeilQuantity = fabricatorSettings.measureUnit === MEASURE_UNITS.Metric;

          let cartItemToAdd = {
            selectionGroup: sqftFeature.subPart.text,
            subGroupTitle: subGroupTitle,
            currentQuote: parentsList.quoteIndex,
            fromVisualizerType,
            quantity: shouldSkipCeilQuantity ? Math.ceil10(sqftFeature.quantity, -2) : Math.ceil(sqftFeature.quantity),
            displayFakeQuantity: sqftFeature.displayFakeQuantity
              ? fabricatorSettings.measureUnit === MEASURE_UNITS.Metric ? Math.ceil10(sqftFeature.displayFakeQuantity, -2) : Math.ceil(sqftFeature.displayFakeQuantity)
              : null,
            displayFakePrice: sqftFeature.displayFakePrice,
            displayFakeFeatureGroupName: sqftFeature.displayFakeFeatureGroupName,
            partId: sqftFeature.subPart.part.partId,
            cartFeature: sqftFeature.feature,
            isBiggestFeature: sqftFeature.isBiggestFeature,
            isQuantityAddedToBiggestFeature: sqftFeature.isQuantityAddedToBiggestFeature,
            quantityGroup: sqftFeature.quantityGroup,
            unit: sqftFeature.unit,
            sqftId: sqftFeature.sqftId,
            sqftIds: sqftFeature.sqftIds,
            shouldUseRelatedParentFeatureAsMain: sqftFeature.shouldUseRelatedParentFeatureAsMain,
            sqftQuantities: sqftFeature.sqftQuantities,
            qtCatName: sqftFeature.qtCatName,
            shouldUseSlabPricing: sqftFeature.shouldUseSlabPricing,
            parentKey,
          };

          if (wizardIsActive && wizardActiveItem) {
            cartItemToAdd = addWizardProperties(cartItemToAdd, sqftFeature);
          }
          addedFeatures.push(cartItemToAdd);
        }

        const remember = Object.assign({}, sqftFeature, {
          currentQuote: parentsList.quoteIndex,
          selectionGroup: sqftFeature.subPart.text,
          partId: sqftFeature.subPart.part.partId,
          subPart: null, // no need to keep it in redux
        });

        const alreadyRememberedIndex = newPreviouslySelectedFeatures.findIndex(existing =>
          existing.sqftId === sqftFeature.sqftId && existing.currentQuote === activeQuoteIndex
        );
        alreadyRememberedIndex >= 0
          ? newPreviouslySelectedFeatures.splice(alreadyRememberedIndex, 1, remember)
          : newPreviouslySelectedFeatures.push(remember);
      }
    }

    console.log("newPreviouslySelectedFeatures", newPreviouslySelectedFeatures);
    changeSqftFeaturesPopup({
      previouslyAddedSqftFeatures: newPreviouslySelectedFeatures
    });

    //we have deleteCartItemsThatAreMissingInParentLists function, but to be consistent we will use deleteCartItemsThatAreMissingInSQFTCalcData
    //deleteCartItemsThatAreMissingInParentLists(parentsLists, cartItems);
    const sqftCalcData = await prepareSQFTData();
    //deleteCartItemsThatAreMissingInSQFTCalcData();
    if (!isSqftPassedDataEmpty(sqftCalcData)) {
      updateActiveQuoteWithSQFTData(sqftCalcData);
    }
    closePopup();
    await updateQuoteRoomsForCartItems(addedFeatures, false, false);
    await updateSQFTCreatedStatusForQuotes();
    deleteSQFTCartItems();
    if (IS_PRODUCT_JOURNEY && wizardActiveItem) {
      setWizardSqftCartItems(addedFeatures); // we are saving them in the wizard reducer in order to add them to the cart later (when wizard is finished)
      console.log("addedFeatures from sqft", addedFeatures);
    } else {
      addToCart(addedFeatures);
    }
    //deleteCartItemsThatAreMissingInSQFTCalcData();
    addCabinetFeatures(cabinetFeatures);
    //todo setRelatedGroups
    if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
      // first set values from added cart items! this is for advanced quoting mostly, but should also skip steps properly
      setWizardValuesFromCartItems(addedFeatures);
    }
    setTimeout(() => { // here we are waiting for addToCart execution (skipAddedSteps needs to know cart items)
      skipAddedSteps();
    }, 0)
    closeSQFtCalc();
  };

  const addCabinetFeatures = (cabinetFeatures) => {
    const relatedGroupsWithNewQuantity = relatedGroups.map(relatedGroup => {
      relatedGroup.relatedFeatures.map(relatedFeature => {
        cabinetFeatures.map(cabinetFeature => {
          if (relatedFeature.dbFeature.id === cabinetFeature.feature.dbFeature.id) {
            relatedFeature.cartQuantity = cabinetFeature.quantity
          }
          return relatedFeature
        })

      });
      return relatedGroup
    });

    setRelatedGroups(relatedGroupsWithNewQuantity);
  }

  /**
   *  Combine features in PARENT_KEYS_WITH_COMBINED_FEATURES_IN_CART with the same feature
   *  into single sqftFeature before adding to the cart
   *  @param sqftFeatures{{}}
   *  @param parentKey{string}
   *  @param quoteIndex{number}
   */
  const prepareSqftFeaturesBeforeAddToCart = (sqftFeatures, parentKey, quoteIndex) => {
    let sqftFeaturesPrepared = [];

    if (PARENT_KEYS_WITH_COMBINED_FEATURES_IN_CART.includes(parentKey)) {
      sqftFeatures.forEach(feature => {
        const alreadyAdded = sqftFeaturesPrepared.find(addedFeature => {
          const isFoundById = addedFeature.feature.dbFeature.id === feature.feature.dbFeature.id;
          const isFoundByName = addedFeature.feature.getSplittedFeatureName() === feature.feature.getSplittedFeatureName();
          //const useSameSlabPricing = addedFeature.shouldUseSlabPricing === feature.shouldUseSlabPricing;

          return (isFoundById || isFoundByName);// && useSameSlabPricing;
        });

        if (alreadyAdded && !feature.disabled) {
          alreadyAdded.sqftIds.push(feature.sqftId);
          alreadyAdded.sqftQuantities[feature.sqftId] = feature.quantity;
          alreadyAdded.quantity += feature.quantity;
          alreadyAdded.quantityRounded += feature.quantityRounded;
          alreadyAdded.initialQuantity += feature.initialQuantity;
          if (alreadyAdded.displayFakeQuantity) {
            alreadyAdded.displayFakeQuantity += feature.displayFakeQuantity;
          }
        } else if (!feature.disabled) {
          sqftFeaturesPrepared.push({
            ...feature,
            parentKey: parentKey,
            quoteIndex,
            sqftIds: [feature.sqftId],
            sqftQuantities: {[feature.sqftId] : feature.quantity},
          });
        }
      });

      // The deleteCartItemsThatAreMissingInSQFTCalcData functionality is linked to this section.
      // If any changes are needed, ensure to update both places to maintain consistency.
      sqftFeaturesPrepared.forEach(sqftFeature => {
        sqftFeature.quantity = fabricatorSettings.measureUnit === MEASURE_UNITS.Metric
          ? Math.ceil10(sqftFeature.quantity, -2)
          : Math.ceil(sqftFeature.quantity);
      });
    } else {
      sqftFeaturesPrepared = sqftFeatures;
    }

    return sqftFeaturesPrepared;
  }

  const addWizardProperties = (cartItemToAdd, sqftFeature) => {
    cartItemToAdd.fromWizardId = wizardActiveItem.id;
    if (sqftFeature.fromWizardGroupId || sqftFeature.newWizardGroupId) {
      cartItemToAdd.fromWizardGroupId = sqftFeature.newWizardGroupId || sqftFeature.fromWizardGroupId;
    }
    const wizardSteps = getWizardGroupsFromTheWizard(
      sqftFeature.subPart.part.dbName || sqftFeature.subPart.part.partName,
      cartItemToAdd.fromWizardGroupId,
      cartItemToAdd.fromWizardGroupId ? null : sqftFeature.feature
    );
    if (wizardSteps.length) {
      const neededWizardStep = wizardSteps.find(wizStep => !wizStep.stepGroups[0].hidePriceNoCart) || wizardSteps[0];
      if (!cartItemToAdd.fromWizardGroupId) {
        cartItemToAdd.fromWizardGroupId = neededWizardStep.stepGroups[0].id;
      }
      cartItemToAdd.fromWizardStep = neededWizardStep.stepIndex;
    } else if (cartItemToAdd && !Number.isInteger(cartItemToAdd.fromWizardStep)
      && Number.isInteger(sqftFeature.fromWizardStep)) {
      cartItemToAdd.fromWizardStep = sqftFeature.fromWizardStep;
    }
    return cartItemToAdd
  }

  return (
    <WithAddToQuote props={props}>
      {(handleAddToQuoteClick, prepareSQFTData) => (
        <WithCloseSQFtCalc props={props}>
          {(closeSQFtCalc) => (
            <button className={"ui-button2 ui-button2--secondary" + (disabled ? " ui-button2--gray" : "")}
                    onClick={() => applyButtonClick(closeSQFtCalc, prepareSQFTData)}>
              <FormattedMessage id={visited || cartItems.length ? "quotingTool.footer.updateCartButton" : "quotingTool.footer.addToCartButton"}/>
            </button>
          )}
        </WithCloseSQFtCalc>
      )}
    </WithAddToQuote>
  )
};

SqftFeaturesPopupApplyButton.propTypes = {
  parentsLists: PropTypes.array,
}

const mapStateToProps = (store) => {
  const {sqftFeaturesPopup, sqftFromFeature} = store.sqftState;
  const {wizardIsActive, wizardActiveItem, wizardList} = store.wizardState;
  return {
    sqftFromFeature,
    sqftFeaturesPopup,
    qtActiveCategory: store.qtState.qtActiveCategory,
    quotes: store.quotesState.quotes,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    cartItems: store.cartState.cartItems,
    showAdvancedQuoting: store.advancedQuotingState.showAdvancedQuoting,
    relatedGroups: store.selectionState.relatedGroups,
    fabricatorSettings: store.fabricatorState.settings,
    wizardList,
    wizardIsActive,
    wizardActiveItem,
  };
};

const mapDispatchToProps = {
  addToCart,
  setQuotes,
  changeSqftFeaturesPopup,
  toggleSelectionFeatureInfo,
  setSqftFromFeature,
  changeCartFeature,
  setRelatedGroups,
  setWizardSqftCartItems,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupApplyButton)
)
